<sc-flex vertical stretchContent fitHeight>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.transport-options-administration.transport-option-editor.title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      <sc-master-detail [selection]="[selectedMenuEntry]" [data]="menuEntries" [readOnly]="true"
        (selectionChanged)="onSelectionChanged($event)" [newStyle]="true">
        <app-transport-option-editor-labeling [transportOption]="transportOption" *ngIf="currentViewKey === 'labeling'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-labeling>
        <app-transport-option-editor-control [transportOption]="transportOption" *ngIf="currentViewKey === 'control'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-control>
        <app-transport-option-editor-validation [transportOption]="transportOption"
          *ngIf="currentViewKey === 'validation'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-validation>
        <app-transport-option-editor-loading [transportOption]="transportOption" *ngIf="currentViewKey === 'loading'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-loading>
        <app-transport-option-editor-parameter [transportOption]="transportOption"
          *ngIf="currentViewKey === 'parameter'" (changed)="onDetailsChanged()"></app-transport-option-editor-parameter>
        <app-transport-option-editor-files [transportOption]="transportOption" *ngIf="currentViewKey === 'files'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-files>
      </sc-master-detail>
    </sc-padding>
  </sc-flex-fitting-content>
  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button class="cancel-button" mat-button (click)="cancelDialog()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-confirm-button primary class="confirm-button" mat-button (click)="confirmDialog()" [disabled]="!optionValid"></sc-confirm-button>
  </sc-actionbar>
</sc-flex>
